const isDev = process.env.NODE_ENV === 'development';

export const logDebug = (...args) => {
  if (isDev) {
    // Keep debug logs out of production builds/runtime noise.
    console.log(...args);
  }
};

